import { Card, Flex, Typography } from "antd"

export const Settings = (props:{applicationId:string})=> {

    return (
        <Flex vertical gap={10}>
            <Flex justify="space-between"><Typography.Title level={3}>Settings</Typography.Title></Flex>
            <Flex gap={10} wrap="wrap">
                <Card title="Web" ></Card>
                <Card title="iOS" ></Card>
                <Card title="Android" ></Card>
            </Flex>
        </Flex>
    )
}